// Swedish message translations
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "Det här svaret förkortades eftersom det nådde längdgränsen och kan vara ofullständigt.",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "Den här förfrågan kan inte besvaras på grund av säkerhetsriktlinjer. Formulera om den eller fråga om ett annat ämne.",
  // Common UI elements
  "Send": "Skicka",
  "Clear chat": "Rensa chatten",
  "Support": "Support",
  "Settings": "Inställningar",
  "Language": "Språk",
  "Theme": "Tema",
  "Font Size": "Teckenstorlek",
  "Select language": "Välj språk",
  
  // Chat interface
  "Type your message...": "Skriv ditt meddelande...",
  "Thinking...": "Tänker...",
  "Ministry of Commerce Laws Expert": "MoC Juridisk Expert",
  "by MJ": "av MJ",
  "Mila": "Mila",
  
  // Frameworks
  "Automatic detection": "Automatisk identifiering",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. HM Bolagslagen",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. HM Lagen om professionella bolag",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. HM Handelsregisterlagen",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. Handelsministerielagen",
  "MOC_TRADE_NAMES_LAW": "A5. HM Lagen om firmanamn",
  "MOC_GCC_TRADEMARK_LAW": "A6. GCC Varumärkeslagen",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. HM Lagen om handelsdokument",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. HM Lagen om kommersiell pant",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. HM Lagen om säkerhet i lös egendom",
  "MOC_INSOLVENCY_LAW": "B4. HM Insolvenslagen",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. HM Lagen om handelsagenturer",
  "MOC_FRANCHISE_LAW": "C2. HM Franchiselagen",
  "MOC_ECOMMERCE_LAW": "C3. HM E-handelslagen",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. HM Lagen om handelskammare",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. HM Lagen om handelsböcker",
  "MOC_COMMERCIAL_DATA_LAW": "D2. HM Lagen om handelsdata",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. HM Lagen om offentlig lagerhållning",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. HM Lagen om standarder och metrologi",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. HM Lagen om kalibrering och mätning",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. HM Lagen om privata laboratorier",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. HM Lagen om ädelmetaller och ädelstenar",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. HM Lagen om hantering av kemikalieimport",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. HM Lagen om redovisning och revision",
  "MOC_VALUERS_LAW": "F2. HM Lagen om värderingsmän",
  "MOC_ENGINEERS_LAW": "F3. HM Lagen om ingenjörer",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. HM Lagen mot döljande",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. HM Lagen mot penningtvätt",
  "MOC_ARBITRATION_LAW": "G3. HM Skiljemannalagen",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. HM Lagen mot kommersiell förfalskning",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. GCC Lagen mot dumpning",
  
  // Models
  "Claude by Anthropic": "Claude från Anthropic",
  "DeepSeek by Groq": "DeepSeek från Groq",
  "MJ Lab Mode": "MJ labbläge",
  
  // Messages
  "Language changed to {{locale}}": "Språket ändrat till {{locale}}",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Hej, jag är {{name}}, en AI-assistent skapad av MJ.",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "Jag är expert på Handelsministeriets lagar och förordningar i Saudiarabien.",
  "Ask me a question, and I will gladly answer you.": "Ställ en fråga till mig, så svarar jag gärna.",
  "Do not share confidential data.": "Dela inte konfidentiell data.",
  "I am powered using": "Jag drivs av",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Ansvarsfriskrivning:** {{name}} är en experimentell AI-assistent designad för att svara med hjälp av data från saudiska Handelsministeriets lagar och förordningar, utan antaganden eller felaktigheter. Jag ansvarar inte för dess beteende eller riktigheten i dess svar.",
  
  // Error messages
  "An error occurred": "Ett fel inträffade",
  "Failed to change language": "Kunde inte ändra språk",
  "Please try again": "Försök igen",
  "Connection lost": "Anslutningen förlorades",
  "Reconnecting...": "Återansluter...",
  "Nothing to clear": "Inget att rensa",
  "All messages cleared": "Alla meddelanden rensade",
  "All data cleared": "All data rensad",
  "Storage limit reached": "Lagringsgränsen har nåtts",
  "Some older messages were removed to save space.": "Vissa äldre meddelanden togs bort för att spara utrymme.",
  "Error": "Fel",
  
  // Tooltips
  "Increase font size": "Öka teckenstorlek",
  "Decrease font size": "Minska teckenstorlek",
  "Reset font size": "Återställ teckenstorlek",
  "Change theme": "Ändra tema",
  "Support the project": "Stöd projektet",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} tecken kvar",
  "{{remainingChars}} characters left": "{{remainingChars}} tecken kvar",
  
  // Message actions
  "Message copied to clipboard": "Meddelandet kopierat till urklipp",
  "Read": "Läs",
  "Summarize": "Sammanfatta",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Meddelandeförslag",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "Välj en fråga för att snabbt starta en konversation om saudiska Handelsministeriets lagar.",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "Vilka är huvudkraven enligt bolagslagen för att etablera ett aktiebolag med begränsat ansvar i Saudiarabien?",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "Hur reglerar lagen om handelsagenturer relationerna mellan utländska företag och saudiska agenter?",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "Vilka skydd ger den saudiska e-handelslagen för online-konsumenter och företag?",
  
  // Audio Player Dialog
  "AI Summary": "AI-sammanfattning",
  "Listen to the summarized response using our AI Service.": "Lyssna på det sammanfattade svaret med vår AI-tjänst.",
  "Generating summary...": "Genererar sammanfattning...",
  "Preparing audio...": "Förbereder ljud...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Kunde inte bearbeta texten. Försök igen.",
  "Failed to auto-play audio. Click play to try again.": "Kunde inte spela upp ljud automatiskt. Klicka på spela för att försöka igen.",
  "Failed to load audio. Please try again.": "Kunde inte ladda ljud. Försök igen.",
  "Audio playback was aborted.": "Ljuduppspelningen avbröts.",
  "Network error occurred while loading audio.": "Nätverksfel uppstod vid laddning av ljud.",
  "Audio decoding failed.": "Ljudavkodning misslyckades.",
  "Audio format not supported.": "Ljudformatet stöds inte.",
  "Failed to setup audio playback": "Kunde inte konfigurera ljuduppspelning",
  "Failed to generate speech": "Kunde inte generera tal",
  "Failed to generate audio. Please try again.": "Kunde inte generera ljud. Försök igen.",
  "Failed to play audio. Please try again.": "Kunde inte spela upp ljud. Försök igen."
};